<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置和获取人脸阀值</h1>
		<h3 class="doc_main_h3">（1）设置人脸识别阈值</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据需求设置人脸识别阈值，值越大识别越严格，建议使用默认值80（不设置即可）。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public boolean SKFaceSetFaceThreshold(int Threshold)；</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">Threshold：int类型，范围50-100</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">boolean类型，true：设置成功，false：设置失败。</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">boolean thresholdState = skFace.SKFaceSetFaceThreshold(80);
//SDK使用示例代码
// 1.初始化SDK
int sdkCode = -1;//SDK授权结果错误码
SKFace skFace = new SKFace(getApplicationContext());
boolean sdkInitState = skFace.SKFaceInitSDK(api_key, api_secret, new SDKInitCallbackInterface() {
    @Override
    public void SDKInitCallback(int code, String msg) {
        Log.e(Tag, "code：" + code + "， msg:" + msg); 
      sdkCode = code;
    }
});

//2.当SDK初始化返回true，并且授权回调Code=0时，可调用视频人脸检测识别初始化函数
if (sdkState && sdkCode == 0){
    boolean initRes = skFace.SKFaceVideoTrackInit(640, 480, 3, false, 0, false);
    if (initRes){
        //3.视频人脸检测识别初始化成功后，在摄像头数据回调函数里调用视频人脸检测识别
        skFace.SKFaceVideoTrackYUV(data, new FaceDetectCallbackInterface() {
            @Override
            public void FaceDetectCallback(FaceStruct[] faceStructs) {
                //这里对回调数据进行处理
                // 这样就可以取到当前视频帧中的第一个人脸的检测识别数据
                FaceStruct firstFaceStruct = faceStructs[0];
            }
        });
    }
}

//4.释放SDK与资源（不使用时）
skFace.SKFaceReleaseSDK();</code></pre>
<h3 class="doc_main_h3">（2）获取人脸识别阈值</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			获取人脸识别阈值。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public int SKFaceGetFaceThreshold()</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">无</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">int类型，人脸识别阈值，范围50-100</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int faceThreshold = SKFaceGetFaceThreshold();</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','基础接口','设置和获取人脸阀值'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/basics/SkfaceSdkethreshold.vue